import { UploadIcon } from '@assets/icons';
import { Button } from '@components/button';
import { useModal } from '@components/modal';
import { VolumeUploadModal } from './VolumeUploadModal';
import { useUploadModal } from './VolumeUploadProvider';

type UploadFileButtonProps = {
  disabled: boolean;
  volumeId: string;
  directory: string[];
  onUploadComplete: () => void;
};

export const UploadFileButton = ({
  disabled,
  volumeId,
  directory,
  onUploadComplete,
}: UploadFileButtonProps) => {
  const { uploadPercentages$, fileNames$, open$ } = useUploadModal();
  const { showModal } = useModal({
    component: VolumeUploadModal,
    componentProps: {
      volumeId,
      directory,
      uploadPercentages$,
      fileNames$,
      open$,
      onFileUploaded: onUploadComplete,
    },
    modalProps: { title: 'Upload file' },
  });

  return (
    <Button startIcon={UploadIcon} variant="primary" disabled={disabled} onClick={showModal}>
      Upload file
    </Button>
  );
};
